export const BANNER_WIDTH = 300;
export const BANNER_HEIGHT = 136;
export const SLIDES_PER_VIEW = 3;
